import { isArray, isEmpty, isFunction, isString, sortBy } from 'lodash-es';

import {
  ClearActionService,
  ExecuteActionService,
  GetActionFnsService,
  GetActionsStoreService,
  RegisterActionService,
  RegisteredActionFn,
} from 'types';

import { registerService } from './register';

/**
 * When an action is registered setting the order prop to lower or higher will
 * determinate the calling order of registered actions.
 */
const DEFAULT_ACTION_ORDER = 1000;

const initActionServices = () => {
  const actionsStore: Record<string, RegisteredActionFn<any, unknown>[]> = {};

  const getActionFns: typeof GetActionFnsService = (name) => {
    if (!isString(name) || isEmpty(name)) {
      throw Error('Action name must be a non-empty string!');
    }

    return actionsStore[name];
  };

  const registerAction: typeof RegisterActionService = (name, fn, { order = DEFAULT_ACTION_ORDER } = {}) => {
    if (!isFunction(fn)) {
      throw Error(`registerAction(${name}): action function (fn) is missing!`);
    }

    const actionFns = getActionFns(name) || [];
    actionFns.push({ fn, order });
    actionsStore[name] = sortBy(actionFns, 'order');
  };

  const clearAction: typeof ClearActionService = (name, fnOrClearAll) => {
    if (fnOrClearAll === true) {
      // clear all action functions under the specified name
      delete actionsStore[name];
      return;
    }

    if (!isFunction(fnOrClearAll)) {
      throw Error(`clearAction(${name}): action function (fn) is missing!`);
    }
    const actionFns = getActionFns(name) || [];
    actionsStore[name] = actionFns.filter((action) => fnOrClearAll !== action.fn);
    if (isEmpty(actionsStore[name])) {
      delete actionsStore[name];
    }
  };

  const executeAction: typeof ExecuteActionService = (name, scope, context) => {
    const actionFns = getActionFns(name);
    if (!isArray(actionFns)) {
      return false;
    }

    actionFns.forEach(({ fn }) => {
      fn(scope, { name, context });
    });

    return true;
  };

  const getActionsStore: typeof GetActionsStoreService = () => actionsStore;

  registerService('registerAction', registerAction);
  registerService('clearAction', clearAction);
  registerService('executeAction', executeAction);
  registerService('getActionFns', getActionFns);
  registerService('getActionsStore', getActionsStore);
};
export default initActionServices;
